import React from 'react';
import { IconButton, Icon } from '@material-ui/core';
import styled from 'styled-components';

const StyledIcon = styled(IconButton)`
  padding: 0;
  span {
    padding-bottom: 0;
    margin-right: 0;
  }
`;

const FormSaveButton = ({ onClick, ...rest }) => (
  <StyledIcon onClick={onClick} {...rest}>
    <Icon>save</Icon>
  </StyledIcon>
);

export default FormSaveButton;
